import React from 'react';

type VarianceBadgeProps = {
  value: number;
  formattedValue: string;
  favorableDirection: 'over' | 'under';
};

export function VarianceBadge({ value, formattedValue, favorableDirection }: VarianceBadgeProps) {
  if (value === 0) return null;

  const direction = value > 0 ? 'over' : 'under';
  const isFavorable = direction === favorableDirection;

  const colorClasses = isFavorable ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700';

  // Strip leading minus sign — the "over"/"under" label already indicates direction
  const displayValue = formattedValue.replace(/^-/, '');

  return (
    <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${colorClasses}`}>
      {displayValue} {direction}
    </span>
  );
}
